<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="content">
    <Header :tabIndex="tabIndex"></Header>
    <div class="nav">
      <div class="nav_head">
        <div class="name">{{ infoLsit[state].name }}</div>
        <div class="nam">ROBOT-BY</div>
      </div>
      <div class="infos">
        <div
          class="item"
          v-for="(item, index) in infoLsit[state].list"
          :key="index"
        >
          <div class="title">{{ item.title }}</div>
          <div class="texts" v-if="item.textList.length == 0">
            <div class="text">{{ item.text }}</div>
          </div>
          <div class="textList" v-else>
            <div class="ite" v-for="(ite, ind) in item.textList" :key="ind">
              <div class="text">{{ ite.text }}</div>
              <div class="text1">{{ ite.text1 }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/header.vue"
import Footer from "@/components/footer.vue"

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      tabIndex: 1,
      state: 0,
      infoLsit: [
        {
          name: "二白机器人",
          list: [
            {
              title: "基本信息",
              text: "中文名：二白机器人\n外文名：RBY\n释义：RBY为“Robot-By”的缩写\n类型：陪伴型机器人品牌/产品系列\n所属公司：杭州二白智能科技有限公司\n公司成立时间：2019年12月\n主要产品：二白Mini机器人\n使用方式：联网使用",
              textList: [],
            },
            {
              title: "概述",
              text: "二白机器人是杭州二白智能科技有限公司旗下的陪伴型机器人品牌与产品系列，面向日常陪伴与互动场景，结合机器人硬件与线上服务，提供持续使用与内容迭代的体验。品牌引入“领养—训练—认主”的阶段化机制，通过线上流程组织用户与生命体的持续互动。",
              textList: [],
            },
            {
              title: "品牌定位",
              text: "二白机器人围绕日常情境下的陪伴与交流需求进行产品设计，强调长期使用中的互动体验与持续成长机制，覆盖居家、办公与外出等日常使用场景。",
              textList: [],
            },
            {
              title: "核心特点",
              text: "",
              textList: [
                {
                  text: "陪伴型互动定位：",
                  text1:
                    "围绕日常情境的陪伴与交流需求进行设计，强调高频、碎片化使用场景的互动体验。",
                },
                {
                  text: "阶段化养成流程：",
                  text1:
                    "采用“领养—训练—认主”的线上流程，将使用体验划分为不同阶段，形成持续使用与成长式体验。",
                },
                {
                  text: "在线服务与内容迭代：",
                  text1:
                    "以联网方式提供服务，支持功能与内容的持续更新，以适配不同阶段的使用需求。",
                },
                {
                  text: "多场景使用：",
                  text1:
                    "覆盖居家、办公与外出等场景，强调随身/桌面场景下的日常陪伴属性。",
                },
              ],
            },
            {
              title: "发展历程",
              text: "",
              textList: [
                {
                  text: "2019年：",
                  text1: "杭州二白智能科技有限公司成立。",
                },
                {
                  text: "2025年6月10日：",
                  text1: "二白Mini机器人创始版开启预售。",
                },
              ],
            },
            {
              title: "产品系列",
              text: "二白Mini机器人：随身/桌面场景的陪伴型机器人产品。",
              textList: [],
            },
            {
              title: "使用与服务",
              text: "线上流程：领养 → 训练 → 认主。\n训练营依托“生命体中心”开展，用户完成生命体领养与取名后，通过训练与互动推进其成长，训练内容涵盖语言、关系与情感等方向，以形成更贴近日常陪伴需求的互动体验。",
              textList: [],
            },
          ],
        },
        {
          name: "二白Mini机器人",
          list: [
            {
              title: "基本信息",
              text: "中文名：二白Mini机器人\n类型：陪伴型机器人/消费级智能硬件\n所属品牌：二白机器人\n出品公司：杭州二白智能科技有限公司\n推出时间：2025年6月10日（创始版预售）\n官方定价：1599元\n使用方式：联网使用\n适用场景：桌面/随身/日常陪伴场景",
              textList: [],
            },
            {
              title: "概述",
              text: "二白Mini机器人是杭州二白智能科技有限公司推出的陪伴型机器人产品，定位于桌面与随身场景的日常陪伴互动设备，通过联网方式提供服务，并结合线上流程与内容机制，形成互动与长期使用体验。",
              textList: [],
            },
            {
              title: "产品定位与使用场景",
              text: "二白Mini机器人面向日常陪伴与互动需求，适用于居家独处、办公桌面与外出随身等场景。",
              textList: [],
            },
            {
              title: "外观与硬件",
              text: "二白Mini机器人采用小型化机身设计，配备屏幕用于显示表情与信息，通过网络连接使用，支持充电使用。",
              textList: [],
            },
            {
              title: "功能与机制",
              text: "",
              textList: [
                {
                  text: "陪伴互动：",
                  text1: "支持用户在日常场景中与机器人进行互动。",
                },
                {
                  text: "训练营机制：",
                  text1:
                    "提供“领养—训练—认主”的线上流程，用于形成阶段化的养成体验。",
                },
                {
                  text: "在线更新：",
                  text1: "部分功能支持线上更新与迭代。",
                },
              ],
            },
            {
              title: "训练营流程",
              text: "二白Mini机器人的训练营流程依托“生命体中心”开展，采用“领养—训练—认主”的阶段化机制。用户完成生命体领养与取名后，通过训练与互动推进其成长，训练内容涵盖语言、关系与情感等方向，以形成更贴近日常陪伴需求的互动体验。",
              textList: [],
            },
            {
              title: "包装与配件",
              text: "二白Mini机器人标准版包装包含：机器人本体、数据线、说明书、感谢信。",
              textList: [],
            },
          ],
        },
      ],
    }
  },
  mounted() {
    this.state = this.$route.query.state
  },
  methods: {
    returnPage() {
      this.$router.back()
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  color: #fff;
  padding-top: 6.875rem;
  .nav {
    width: 100%;
    box-sizing: border-box;
    padding: 0 1rem;
    .nav_head {
      margin-bottom: 1.25rem;
      .name {
        font-size: 1.25rem;
        font-weight: bold;
        margin-bottom: 0.625rem;
      }
      .nam {
        opacity: 0.5;
        font-family: Alibaba PuHuiTi 2;
        font-style: 65 Medium;
        font-size: 0.875rem;
        leading-trim: NONE;
        line-height: 100%;
        letter-spacing: 30%;
        text-align: center;
      }
    }
    .infos {
      .item {
        margin-bottom: 0.625rem;
        padding: 1rem;
        border-radius: 0.5rem;
        background-color: #ffffff0d;
        text-align: left;
        .title {
          font-size: 0.875rem;
          margin-bottom: 0.75rem;
        }
        .texts {
          .text {
            line-height: 1.125rem;
            font-size: 0.75rem;
            opacity: 0.65;
            white-space: pre-line;
          }
        }
        .textList {
          .ite {
            display: flex;
            align-items: start;
            opacity: 0.65;
            line-height: 1.125rem;
            .text {
              font-size: 0.75rem;
              font-weight: 600;
              white-space: nowrap;
            }
            .text1 {
              font-size: 0.75rem;
            }
          }
        }
      }
    }
  }
}
</style>
